export const getApproval = (id) => (state) =>
  state.jsonApiEntities &&
  state.jsonApiEntities.assignment &&
  state.jsonApiEntities.assignment[id]
